import { render } from "./LegacyNewPassword.vue?vue&type=template&id=8af2bbbe&ts=true"
import script from "./LegacyNewPassword.vue?vue&type=script&lang=ts"
export * from "./LegacyNewPassword.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__